import { Directive, Input, HostListener, ElementRef } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * @whatItDoes Adds a click event that scrolls the window to the top.
 * If passed a scrollToTopElement then scrolls that element instead of the window.
 *
 * Since this app uses routes we can't just use an href="#" to scroll to the top.
 *
 * @howToUse
 *
 * <a href="#" wl-scroll-to-top (click)="$event.preventDefault()">Scroll to top</a>
 */
@Directive({
  selector: '[wl-scroll-to-top]',
  standalone: false
})
export class WlScrollToTopDirective {
  /**
   * (Optional)
   * The element that should scroll when this is clicked.
   * If not set the assumes window.
   */
  @Input() public scrollToTopElement: ElementRef = null;

  /**
   * bind the host's click event
   */
  @HostListener('click') public handleClick(): void {
    this.scrollBodyToTop();
  }

  /**
   * injection goes here
   */
  constructor() {}

  /**
   * scroll given element or window to top
   */
  public scrollBodyToTop(): void {
    // should scroll the window?
    if (!this.scrollToTopElement) {
      this.scrollWindowToTop();
      return;
    }

    // should never happen
    if (this.scrollToTopElement && !this.scrollToTopElement.nativeElement) return;

    let element: Element = <Element>this.scrollToTopElement.nativeElement;

    if (element) element.scrollTop = 0;
  }

  /**
   * scroll window to top
   */
  public scrollWindowToTop(): void {
    window.scrollTo(0, 0);
  }
}
